


































































































































import {Component, Vue} from 'vue-property-decorator';
import PaginateButtons from '@/layouts/gripper/components/PaginateButtons.vue';
import ImagesGrid from '@/layouts/gripper/components/QuickLabeling/ImagesGrid.vue';
import HotkeyListener from '@/layouts/gripper/hotkeys/HotkeyListener.vue';
import {Condition, ConditionState, Parameter, Pipeline, Resource, ReviewResource} from '@/types/gripper';
import HotkeyLegend from '@/layouts/gripper/hotkeys/HotkeyLegend.vue';
import {
  JobDataset_job_dataset_resources_data as Resources_data, ReviewInfo,
  ReviewInfo_conditions_data,
  ReviewInfo_parameters,
  ReviewInfo_parameters_data,
  SearchValueInput,
} from '@/types/intrador';
import ConfirmDialog from '@/pages/ConfirmDialog.vue';

@Component({
  components: {
    ConfirmDialog,
    HotkeyListener,
    PaginateButtons,
    HotkeyLegend,
    ImagesGrid,
  },
  metaInfo: {
    title: 'ChecksReview',
  },
})
export default class ChecksReview extends Vue {

  private data: ReviewInfo_parameters | null = null;
  private parameters: Parameter[] = [];
  private conditions: Condition[] = [];
  private selectedParameterID: number = 592;
  private selectedConditionID: string = '';
  private selectedOptionID: string = '1';
  private requestIsLoading = false;
  private askForDeleteConfirmation = false;

  private imageHeight: string = '100px';
  private selectedOptionType: object = {option_id: '1', label: 'True'};
  private numCols: number = 10;
  private page: number = 1;
  private limit: number = 10000;
  private resourcePage: number = 1;
  private totalResourcePages: number = 1;
  private resourcesLimit: number = 250;
  private minId: number = 0;
  private maxId: number = 9999999999999;

  private imagesData: ReviewResource[] = [];
  private isDragging: boolean = false;
  private panel: number[] = [0, 1];
  private disabled: boolean = false;

  private rightClickMenuoptionsOverride: any = [
    {
      name: 'Uitvergrote foto',
      slug: 'more_detail',
    },
    {
      name: 'Bekijk resource',
      slug: 'view_resource',
    },
  ];

  get queryVariablesParameters() {
    return {
      page: this.page,
      limit: this.limit,
    };
  }

  get queryVariablesChecks() {
    const ret = {
      parameterId: this.selectedParameterID,
      limit: this.resourcesLimit,
      page: this.resourcePage,
      whereChecks: [{
        parameter_id: this.selectedParameterID.toString(),
        value: this.selectedOptionID,
        has: true,
      } as SearchValueInput],
      whereCondition: parseInt(this.selectedConditionID, 10),
    } as any;
    if (this.minId) {
      ret.minId = this.minId;
      ret.page = 1;
    }
    return ret;
  }

  private resolveDataParameters(data: ReviewInfo) {
    this.data = data.parameters;
    if (data && data.parameters && data.conditions && data.parameters.data && data.conditions.data) {
      data.parameters.data.forEach((parameter: ReviewInfo_parameters_data) => {
        this.parameters.push({
          name: parameter.name,
          slug: parameter.id + ' | ' + parameter.name + ' | ' + parameter.type,
          id: parameter.id,
          type: parameter.type,
        } as Parameter);
      });
      data.conditions.data.forEach((condition: ReviewInfo_conditions_data) => {
        this.conditions.push({
          name: condition.name,
          slug: condition.id + ' | ' + condition.name,
          id: condition.id,
        } as Condition);
      });
    }
  }

  private reload() {
    this.resourcePage = 1;
    this.totalResourcePages = 1;
    this.imagesData = [];
    this.loadChecksData();
  }

  private loadChecksData() {
    this.requestIsLoading = true;
    this.$apollo.query({
      query: require('@/graphql/ChecksReview.graphql'),
      variables: this.queryVariablesChecks,
    }).then((result: any) => {
      this.totalResourcePages = Math.ceil(result.data.resources.paginatorInfo.total / this.resourcesLimit);
      this.imagesData = [];

      result.data.resources.data.forEach((item: any) => {

        if (this.imagesData.findIndex((i: Resource) => i.id === item.id) < 0) {
          const resource: ReviewResource = {
            id: item.id,
            url: item.url,
            isSelected: true,
            isMutating: false,
            isDeleted: false,
            checkId: item.checks[0].id,
            type: item.type,
          };
          this.imagesData.push(resource);
        }
      });

      this.requestIsLoading = false;
    }).catch((error) => {
      this.$swal('Error', error.message, 'warning');
    });
  }

  private markResource(resource: Resource) {
    // mark the resouce as remove (set option to null) or set resource to belong to the current selected label
    resource.isSelected = !resource.isSelected;
    this.removeCheck(resource);
  }

  private async removeCheck(resource: any) {
    resource.isMutating = true;

    this.$apollo.mutate({
      mutation: require('@/graphql/mutations/DeleteCheck.graphql'),
      variables: {
        id: resource.checkId,
      },
    }).catch((error) => {
      this.$swal('Error', error.message, 'warning');
    });

    resource.isMutating = false;

    const indexInArray = this.imagesData.findIndex((i: any) => i.id === resource.id);
    this.imagesData[indexInArray].isDeleted = true;

    if (this.imagesData.length === 0) {
      this.loadChecksData();
    }
  }

  private setSelectedParameterID(parameterID: any) {
    this.selectedParameterID = parameterID;
  }

  private setOptionID(optionID: any) {
    this.selectedOptionID = optionID;
    this.reload();
  }

  private setSelectedConditionID(conditionID: any) {
    this.selectedConditionID = conditionID;
  }

  private async pageChange(newPage: number) {
    this.resourcePage = newPage;
    this.imagesData = [];
    this.loadChecksData();
  }

  private async delRecord(resource: Resource) {
    if (this.askForDeleteConfirmation && await (this.$refs.confirm as any).open(
      'Confirm',
      'Are you sure you want to delete this record?')
    ) {
      this.markResource(resource);
    } else if (!this.askForDeleteConfirmation) {
      this.markResource(resource);
    }
  }

}
